<template>
  <div class="catalog-dir" :class="isAffix ? 'fixed-dir' : ''" :style="{ height: viewHeight, top: affixTop }">
    <div class="mask-disable-drag" :class="`sortable-disable-${categoryId}`"></div>
    <tree-list
      ref='tree'
      @dirChanged="dirChanged"
      :defaultExpandedKeys="defaultExpandedKeys"
      :currentKey="currentKey"
      :defaultNode='defaultNode'
      :categoryType='categoryType'
      :compID="compID"
      :lazy="lazy"
      :sortable="sortable"
      :orderBy="orderBy"
    >
    </tree-list>
  </div>
</template>

<script>
import {Category} from "@/libs";

import TreeList from './tree-list.vue';

export default {
  components: {TreeList},
  props: {
    viewHeight: { default: 'calc(100vh - 20px)' }, // 目录的容器高度
    affixTop: { default: '0' }, // 目录的容器top固定值
    compID: { default: '' },
    title: { default: '' },
    categoryType: { default: '' },
    orderBy: { default: '' },
    lazy: { default: true },
    isClickToTrigger: { default: false }, // 是否点击树就触发
    defaultNode: { default: [{DirName: "全部", DirID: 0, TreeID: 'list_0'}] },
    sortable: Boolean,
    defaultExpandedKeys: {
      type: Array,
      default() {
        return ['list_0'];
      }
    },
    currentKey: {
      type: String,
      default: 'list_0'
    }
  },
  data() {
    return {
      isAffix: false,
      categoryId: Category[this.categoryType],
    }
  },
  methods: {
    dirChanged(data, node, isNow = false) {
      if (isNow && !this.isClickToTrigger) return;
      // === 当前节点的所有父节点数组 ===
      let parents=[node.data];
      let obj = node;
      while (obj.parent.data && obj.parent.data.DirName){
          parents.push(obj.parent.data);
          obj = obj.parent;
      }
      this.$emit('dirChanged', data, parents)
    },
    affixChange(isAffix) {
      if (!this.affix) return;
      this.isAffix = isAffix;
    },
    dragDataCallback(params = {}) {
      this.$refs.tree.dragDataCallback(params);
    },
    select(treeID) {
      this.$refs.tree.select(treeID);
    },
  }
}
</script>

<style lang="less" scoped>
.catalog-dir{
  min-width: 28px;
  // min-width: 230px;
  max-width: 500px;
  background: #eeeeee;
  border-right: 1px solid #d6d6d6;
  // box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
  position: sticky;
  display: flex;
  flex-direction: column;
  z-index: 9;
  /deep/ .el-tree{
    // padding: 10px;
  }
  .title{
    height: 40px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    padding-left: 16px;
    z-index: 1;
    font-size: 14px;
    span{
      font-weight: 400;
      color: #0989C5;
      line-height: 40px;
      background: linear-gradient(90deg, #0A89C5 0%, #995CB6 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  /deep/ .el-tree{
    height: calc(100vh - 32px - 40px);
    overflow: auto;
  }
  &.fixed-dir{
    /deep/ .el-tree{
      overflow-y: auto;
    }
  }
}
.mask-disable-drag{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: #ffffff;
  opacity: 0.5;
  cursor: no-drop;
  display: none;
}
</style>
